var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeLinkedinIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 111.634,
    viewBox: "0 0 102 111.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M22.384,109.634H1.652v-73.2H22.384ZM12.007,26.453C5.377,26.453,0,20.433,0,13.164S5.376,0,12.007,0,24.013,5.894,24.013,13.164,18.634,26.453,12.007,26.453Zm87.971,83.181H79.29V74c0-8.492-.156-19.382-10.779-19.382-10.779,0-12.431,9.226-12.431,18.77v36.243H35.371v-73.2H55.254v9.985h.29A21.521,21.521,0,0,1,75.161,34.6C96.143,34.6,100,49.75,100,69.426v40.208Z",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#df5757",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeLinkedinIn);
export default __webpack_public_path__ + "static/media/Icon awesome-linkedin-in.4390475b256f2ab1bb673e94347edce8.svg";
export { ForwardRef as ReactComponent };